import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=56b8f222&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=56b8f222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_etfl7lgzzfti5tuwpbu7orzhm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8f222",
  null
  
)

export default component.exports